import type { ReactNode } from "react";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "~/atoms/tabs";
import { cn } from "~/lib/utils";

export type PanelTab = {
  id: string;
  label: ReactNode;
  content: ReactNode;
  badge?: ReactNode;
};

interface PanelTabsProps {
  tabs: PanelTab[];
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
}

export const PanelTabs = ({
  tabs,
  value,
  onValueChange,
  className,
}: PanelTabsProps) => {
  return (
    <Tabs value={value} onValueChange={onValueChange} className={className}>
      <TabsList className="flex w-full items-end bg-transparent p-0">
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.id}
            value={tab.id}
            className={cn(
              "border-border flex-1 border text-xs font-medium shadow-transparent",
              // eslint-disable-next-line better-tailwindcss/no-restricted-classes -- negative margin for border overlap between tabs
              "h-10 rounded-t-lg rounded-b-none not-last:-mr-px",
              "data-[state=active]:bg-card data-[state=active]:h-12 data-[state=active]:border-b-0 data-[state=active]:px-4 data-[state=active]:text-sm data-[state=active]:font-medium",
              "transition-transform duration-200",
              tab.badge && "relative",
            )}
          >
            {tab.label}
            {tab.badge}
          </TabsTrigger>
        ))}
      </TabsList>

      {tabs.map((tab) => (
        <TabsContent
          key={tab.id}
          value={tab.id}
          className="bg-card rounded-b-lg border-r border-b border-l px-4 py-6"
        >
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  );
};
